import { ChannelSettingToggleTextarea } from './ChannelSettingToggleTextarea';

export function ChannelQuestionsToIgnoreSection({
  isEnabled,
  value,
  onToggle,
  onValueChange,
  isReadOnly = false,
}: {
  isEnabled: boolean;
  value: string;
  onToggle: (enabled: boolean) => void;
  onValueChange: (value: string) => void;
  isReadOnly?: boolean;
}) {
  return (
    <ChannelSettingToggleTextarea
      title="Questions to Ignore"
      description="Customize which questions the agent should ignore in this channel"
      isEnabled={isEnabled}
      value={value}
      onToggle={onToggle}
      onValueChange={onValueChange}
      placeholder="Describe types of questions to ignore (optional)"
      minRows={3}
      helperText="When enabled, this overrides the team-level setting for this channel."
      isReadOnly={isReadOnly}
    />
  );
}
